import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Trust } from './components/Trust';
import { Services } from './components/Services';
import { WhoThisIsFor } from './components/WhoThisIsFor';
import { WhatMakesDifferent } from './components/WhatMakesDifferent';
import { HowItWorks } from './components/HowItWorks';
import { Cities } from './components/Cities';
import { Pricing } from './components/Pricing';
import { EligibilityComparison } from './components/EligibilityComparison';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <Trust />
      <Services />
      <WhoThisIsFor />
      <WhatMakesDifferent />
      <HowItWorks />
      <Cities />
      <Pricing />
      <EligibilityComparison />
      <FinalCTA />
      <Footer />
    </div>
  );
}
